module.exports = __webpack_public_path__ + "img/ig.37b1907b.svg";